import Vue from "vue";
import Vuex from "vuex";
// import axios from 'axios'
import axios from "./axios";
import configfile from "../config/config";
import qs from "qs";
import { generateApiURL } from "./mixins";
// import {FlightCrewListRes , CourseCrewListRes , crewRosterRes} from '../mock/mockData'

Vue.use(Vuex);
Vue.prototype.$axios = axios;
let config = configfile.config;

export default new Vuex.Store({
  state: {
    isPersonExist: true,
    isReturnNoDuty: false,
    tokenReady: false,
    isImpersonation: false,
    impersonateMail: "",
    isImpersonation: false,
    roster: [],
    flightCrewList: [],
    courseCrewList: []
  },
  getters: {
    isPersonExist: state => state.isPersonExist,
    isReturnNoDuty: state => state.isReturnNoDuty,
    tokenReady: (state) => state.tokenReady,
    roster: state => state.roster,
    flightCrewList: state => state.flightCrewList,
    courseCrewList: state => state.courseCrewList,
    isImpersonation: state => state.isImpersonation,
    impersonateMail: state => state.impersonateMail
  },
  mutations: {
    setImpersonateMail: function(state, impersonateMail) {
      state.impersonateMail = impersonateMail;
    },
    setIsPersonExist(state, isPersonExist) {
      state.isPersonExist = isPersonExist;
    },
    setIsReturnNoDuty(state, isReturnNoDuty) {
      state.isReturnNoDuty = isReturnNoDuty;
    },
    setTokenReady(state, tokenReady) {
      state.tokenReady = tokenReady;
    },
    setCrewRoster(state, roster) {
      state.roster = roster;
    },
    setFlightCrewList(state, flightCrewList) {
      state.flightCrewList = flightCrewList;
    },
    setImpersonation(state, bool) {
      state.isImpersonation = bool;
    },
    setCourseCrewList(state, courseCrewList) {
      state.courseCrewList = courseCrewList;
    }
  },
  actions: {
    setImpersonateMail: ({ commit }, mail) => {
      commit("setImpersonateMail", mail);
    },
    setImpersonation: ({ commit }, bool) => {
      commit('setImpersonation', bool);
    },
    loginAuth: () => {
      const authUrl =
        "//login.microsoftonline.com/" +
        config.token["tenant_id"] +
        "/oauth2/v2.0/authorize" +
        ("?" +
          qs.stringify({
            client_id: config.token["client_id"],
            response_type: "code",
            scope: config.token["scope"]
          }));
      window.location = authUrl;
    },
    logout: () => {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        resolve(true);
      });
    },
    getCrewRoster({ commit }, axiosData) {
      // const { roster } = crewRosterRes.data;
      // commit("setCrewRoster", roster)
      return new Promise((resolve, reject) => {
        axios({
          url: `${generateApiURL("/rosters")}/recent-briefing`,
          method: "POST",
          headers: {
            "Content-type": "application/json",
            'Authorization': localStorage.getItem('access_token'),
          },
          data: axiosData
        })
          .then(resp => {
            if (!resp.data.data) {
              commit("setIsPersonExist", true);
              commit("setIsReturnNoDuty", true);
              return;
            }
            commit("setCrewRoster", resp.data.data.roster);
            commit("setIsPersonExist", true);
            commit("setIsReturnNoDuty", false);
            resolve(resp.data.data.roster);
          })
          .catch(err => {
            console.log("err", err);
            commit("setIsPersonExist", false);
            reject(err);
          });
      });
    },
    getFlightCrewList({ commit }, axiosData) {
      // const { crewList } = FlightCrewListRes.data;
      // commit("setFlightCrewList", crewList)
      return new Promise((resolve, reject) => {
        axios({
          url: `${generateApiURL("/rosters")}/crew`,
          method: "Get",
          headers: {
            "Content-type": "application/json",
          },
          params: axiosData
        })
          .then(resp => {
            commit("setFlightCrewList", resp.data.data.crewList);
            resolve();
          })
          .catch(err => {
            console.log("err", err);
            reject(err);
          });
      });
    },
    getCourseCrewList({ commit }, axiosData) {
      // const { crewList } = CourseCrewListRes.data;
      // commit("setCourseCrewList", crewList);
      return new Promise((resolve, reject) => {
        axios({
          url: `${generateApiURL("/rosters")}/training-crew`,
          method: "Get",
          headers: {
            "Content-type": "application/json"
          },
          params: axiosData
        })
          .then(resp => {
            commit("setCourseCrewList", resp.data.data.crewList);
            resolve();
          })
          .catch(err => {
            console.log("err", err);
            reject(err);
          });
      });
    },
    setImpersonation: ({ commit }, bool) => {
      commit('setImpersonation', bool);
    },
    logoutout: () => {
      const authUrl =
        "//login.microsoftonline.com/" +
        config.token["clientId"] +
        "/oauth2/v2.0/logout" +
        ("?" +
          qs.stringify({
            post_logout_redirect_uri: config.post_logout_redirect_uri
          }));
      window.location = authUrl;
    }
  }
});
